//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { QueryRenderer, ReadyState } from "react-relay";
// feed-scheduler-input-renderer imports
import { FeedSchedulerInput } from "./FeedSchedulerInput";
import { query } from "./FeedSchedulerInputRenderer.gql";
// other internals
import { CalloutBox } from "#webapp/src/components/callout-box";
// util
import { handleReadyStateError } from "#webapp/src/util/relay.util";
import { getCurrentEnvironment } from "../../state/relay-environment";
import { IAttendee } from "./FeedSchedulerInputTypes";

interface Props {
  queryInput?: string;
  orgId: string;
  excludeCalendars?: string[];
  initialPersons: IAttendee[];
  selectedPersons: IAttendee[];
  onChange: (calendarIds: string[]) => void;
}

//////////////////
// COMPONENT
//////////////////
export const FeedSchedulerInputRenderer = ({
  queryInput,
  excludeCalendars,
  orgId,
  initialPersons,
  selectedPersons,
  onChange,
}: Props) => {
  const emails: string[] = [];
  const externalGroupRefetch = false;
  const teamId = "";
  const teamAttendeesRefetch = false;

  return (
    <QueryRenderer
      environment={getCurrentEnvironment()}
      query={query}
      variables={{
        queryInput: queryInput || "",
        orgRelayId: orgId,
        excludeCalendars: excludeCalendars || [],
        emails,
        externalGroupRefetch,
        teamId,
        teamAttendeesRefetch,
      }}
      cacheConfig={{}}
      render={(readyState: ReadyState) => {
        const viewer = readyState.props && readyState.props.viewer;
        const org = readyState.props && readyState.props.org;

        if (readyState.error) {
          handleReadyStateError(readyState.error, "FeedSchedulerInputRenderer");
        }

        // check for error or show a loader for first load
        if (readyState.error) {
          return (
            <CalloutBox error style={{ marginTop: 20 }}>
              An error has occurred. Please try refreshing the page.
            </CalloutBox>
          );
        }

        return (
          <FeedSchedulerInput
            viewer={viewer}
            org={org}
            initialPersons={initialPersons}
            selectedPersons={selectedPersons}
            onChange={onChange}
          />
        );
      }}
    />
  );
};
